import { render, staticRenderFns } from "./IpoAllocatedInformation.vue?vue&type=template&id=232a137c"
import script from "./IpoAllocatedInformation.vue?vue&type=script&lang=js"
export * from "./IpoAllocatedInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports